import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { setDataTableColumns, setPlayer } from "../actions";
import { handleNewCharacterLandscapeCols } from "./landscapecols";
import { activeGameSelector, dataTableSettingsSelector, gameDetailsSelector, modeNameSelector, selectedCharactersSelector } from "../selectors";
import { PlayerId } from "../types";

interface UseCharacterSelectParams {
  handleModalDismiss?: () => void;
  setSearchText?: (text: string) => void;
}

export const useCharacterSelect = ({
  handleModalDismiss,
  setSearchText,
}: UseCharacterSelectParams) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const gameDetails = useSelector(gameDetailsSelector);
  const selectedCharacters = useSelector(selectedCharactersSelector);
  const autoSetCharacterSpecificColumnsOn = useSelector(dataTableSettingsSelector).autoSetCharacterSpecificColumnsOn;
  const dataTableColumns = useSelector(dataTableSettingsSelector).tableColumns;
  const modeName = useSelector(modeNameSelector);
  const activeGame = useSelector(activeGameSelector);

  const onCharacterSelect = useCallback(
    (playerId: PlayerId, charName: string) => {
      handleModalDismiss?.();

      dispatch(
        setDataTableColumns(
          handleNewCharacterLandscapeCols(
            gameDetails,
            selectedCharacters[playerId]?.name,
            charName,
            autoSetCharacterSpecificColumnsOn,
            dataTableColumns
          )
        )
      );

      dispatch(setPlayer(playerId, charName));

      setSearchText?.("");

      if (modeName === "home") {
        history.push(`/framedata/${activeGame}/${charName}`);
      } else if (
        playerId === "playerOne" &&
        (modeName === "framedata" || modeName === "moveslist" || modeName === "combos")
      ) {
        history.replace(`/${modeName}/${activeGame}/${charName}`);
      }
    },
    [
      dispatch,
      gameDetails,
      selectedCharacters,
      autoSetCharacterSpecificColumnsOn,
      dataTableColumns,
      modeName,
      activeGame,
      handleModalDismiss,
      setSearchText,
      history,
    ]
  );

  return { onCharacterSelect };
};
